import {useState, useContext} from 'react'
import {tonConnectUI} from '../tonConnectUI'
import {WalletContext} from '../components/WalletContext'
import {useNavigate, useLocation} from 'react-router-dom'
import {Address} from '@ton/core'
import './Navbar.css'

export default function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false)
    const [showCopied, setShowCopied] = useState(false)
    const {walletAddress} = useContext(WalletContext)
    const navigate = useNavigate()
    const location = useLocation()

    const toggleMenu = () => setMenuOpen(!menuOpen)

    const connectWallet = async () => {
        await tonConnectUI.openModal()
    }

    const disconnectWallet = () => {
        tonConnectUI.disconnect()
    }

    const handleSectionNav = id => {
        setMenuOpen(false)
        if (location.pathname !== '/') {
            navigate('/')
            setTimeout(() => {
                const section = document.getElementById(id)
                if (section) {
                    section.scrollIntoView({behavior: 'smooth'})
                }
            }, 100)
        } else {
            const section = document.getElementById(id)
            if (section) {
                section.scrollIntoView({behavior: 'smooth'})
            }
        }
    }

    const shortenAddress = address => {
        try {
            const friendly = Address.parse(address).toString({bounceable: false})
            return friendly.slice(0, 6) + '...' + friendly.slice(-4)
        } catch (e) {
            return address.slice(0, 6) + '...' + address.slice(-4)
        }
    }

    const copyAddress = () => {
        if (walletAddress) {
            try {
                const fullFriendly = Address.parse(walletAddress).toString({
                    bounceable: false,
                })
                navigator.clipboard.writeText(fullFriendly)
            } catch {
                navigator.clipboard.writeText(walletAddress)
            }
            setShowCopied(true)
            setTimeout(() => setShowCopied(false), 1500)
        }
    }

    return (
        <>
            {showCopied && <div className='copied-overlay'>Copied</div>}

            <nav className='navbar'>
                <div className='navbar-logo'>
                    It's <br/>
                    Fucken.Me!
                </div>

                <div
                    className={`burger ${menuOpen ? 'open' : ''}`}
                    onClick={toggleMenu}
                >
                    <span/>
                    <span/>
                    <span/>
                </div>

                <ul className={`navbar-links ${menuOpen ? 'active' : ''}`}>
                    <li>
                        <button
                            className='navbar-link'
                            onClick={() => handleSectionNav('home')}
                        >
                            Home
                        </button>
                    </li>
                    <li>
                        <button
                            className='navbar-link'
                            onClick={() => handleSectionNav('nfts')}
                        >
                            NFT
                        </button>
                    </li>
                    <li>
                        <button
                            className='navbar-link'
                            onClick={() => handleSectionNav('about')}
                        >
                            About Us
                        </button>
                    </li>
                    <li>
                        <a href='/galery-nfts' onClick={() => setMenuOpen(false)}>
                            Our Collection
                        </a>
                    </li>
                    {walletAddress && (
                        <li>
                            <a href='/mint' onClick={() => setMenuOpen(false)}>
                                Mint NFT
                            </a>
                        </li>
                    )}
                    {walletAddress && (
                        <li>
                            <a href='/my-nfts' onClick={() => setMenuOpen(false)}>
                                My NFTs
                            </a>
                        </li>
                    )}
                    <li className='wallet-button-wrapper'>
                        {walletAddress ? (
                            <div className='wallet-info'>
								<span
                                    className='wallet-address'
                                    onClick={copyAddress}
                                    style={{cursor: 'pointer'}}
                                >
									{shortenAddress(walletAddress)}
								</span>
                                <button
                                    className='wallet-button logout'
                                    onClick={disconnectWallet}
                                >
                                    Logout
                                </button>
                            </div>
                        ) : (
                            <button className='wallet-button' onClick={connectWallet}>
                                Connect Wallet
                            </button>
                        )}
                    </li>
                </ul>
            </nav>
        </>
    )
}
